<template>
  <el-radio :label="label" :border="border" :data-qa="dataQa">
    <div class="label">
      <slot />
    </div>
  </el-radio>
</template>

<script>
export default {
  name: 'RadioCustom',

  props: {
    label: {
      required: true
    },

    border: {
      type: Boolean,
      default: false
    },

    dataQa: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
.el-radio {
  display: flex;
  border-color: #dbdee7;
  box-sizing: border-box;
  padding: 4px 14px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-radio.is-bordered {
  height: 54px;
  padding: 10px 14px;
}

.el-radio.is-bordered.is-checked {
  border-color: #1d87c8;
  background-color: #e6f3fb;
}

.el-radio >>> .el-radio__input {
  display: flex;
  align-items: center;
  flex: 0;
}

.el-radio >>> .el-radio__label {
  display: flex;
  align-items: center;
  padding-left: 14px;
  flex: 1;
}

.label {
  font-size: 14px;
  line-height: 18px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/locations/RadioCustom.vue